import React from 'react'
import { Navbar } from './components'
import { Outlet } from 'react-router-dom'

const Layout = ({setName}) => {
  return (
    <div className='dark:bg-gray-700 min-h-screen dark:text-white'>
        <Navbar setName={setName}/>
        <Outlet/>
    </div>
  )
}

export default Layout